import { GetterTree } from "vuex";
import { FridgeDetailsState, RootState } from "@/types/fridgeDetails";
import NativeClient from "@/client/native-client";

const getters: GetterTree<FridgeDetailsState, RootState> = {
  getEconaviInfo: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getEconaviInfo start");
    return state.econaviInfo;
  },
  // ドア開閉情報
  getDoorOpenInfo: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getDoorOpenInfo start");
    return state.doorOpenInfo;
  },
  // Push通知設定状態取得
  getPushSettings: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getPushSettings start");
    return state.pushSettings;
  },
  // 電気代減額データ取得
  getReductionInfo: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getReductionInfo start");
    return state.reductoinInfo;
  },
  getSettings: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getSettings start");
    const retValue = state.settings;
    if (retValue != null && state.operationSettings != null) {
      retValue.house_sitting_status  = state.operationSettings.house_sitting_status;
      retValue.pre_cooling_status    = state.operationSettings.pre_cooling_status;
      retValue.winter_setting_status = state.operationSettings.winter_setting_status;
      retValue.outage_prepare_status = state.operationSettings.outage_prepare_status;
    }
    return retValue;
  },
  // 設定値有効／無効
  getFunctionList: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getFunctionList start");
    return state.functionList;
  },
  // 設定値保存
  getSettingsBuffer: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getSettingsBuffer start");
    return state.settingsBuffer;
  },
  // 通知設定保存
  getPushSettingsBuffer: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getPushSettingsBuffer start");
    return state.pushSettingsBuffer;
  },
  // クーリングアシストのトップ画面の洗濯中のタブ
  getCoolingAssistTopTab: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getCoolingAssistTopTab start");
    return state.coolingAssisttopTabIdex;
  },
  // クーリングアシストのパラメータ設定
  getCoolingAssistSettings: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getCoolingAssistSettings start");
    return state.coolingAssisySettings;
  },
  // クーリングアシストのマイリスト（マイリスト）の取得
  getMyAssist: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters getMyAssist start");
    return state.myAssist;
  },
  getSettingsInitialValue: (state: FridgeDetailsState) => {
    return state.settingsInitialValue;
  },
  getDoorMonitorTabIndex: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters.ts getDoorMonitorTabIndex() start index = " + state.doorMonitorTabIndex);
    return state.doorMonitorTabIndex;
  },
  getDoorMonitorDailyTabIndex: (state: FridgeDetailsState) => {
    NativeClient.sendDebugLog("getters.ts getDoorMonitorDailyTabIndex() start index = " + state.doorMonitorDailyTabIndex);
    return state.doorMonitorDailyTabIndex;
  },
  getDisplayDescriptionList: (state: FridgeDetailsState) => {
    return state.descriptionList;
  }
};

export default getters;